// Linear Product Page JavaScript

// State variables
let selectedColor = null;
let selectedWidth = null;

// Extract color from variant title
function extractColor(variantTitle) {
  if (!variantTitle) return null;
  if (variantTitle.includes('/')) {
    return variantTitle.split('/')[0].trim();
  } else if (variantTitle.includes('-')) {
    return variantTitle.split('-')[0].trim();
  }
  return variantTitle.trim();
}

// Extract width from variant title
function extractWidth(variantTitle) {
  if (!variantTitle) return null;
  const match = variantTitle.match(/(\d+(?:\.\d+)?)\s*m(?:\s|$|,|-|\)|\])/i);
  return match ? parseFloat(match[1]) : null;
}

// Get available widths for a color (or all widths if no color provided)
function getWidthsForColor(color) {
  const widths = new Set();
  const variantMap = window.linearProductData?.variantMap || {};
  
  for (const [key, variant] of Object.entries(variantMap)) {
    const variantWidth = extractWidth(variant.title);
    if (!variantWidth) continue;

    if (!color) {
      widths.add(variantWidth);
    } else {
      const variantColor = extractColor(variant.title);
      if (variantColor && variantColor.toLowerCase() === color.toLowerCase()) {
        widths.add(variantWidth);
      }
    }
  }
  
  return Array.from(widths).sort((a, b) => a - b);
}

// Get first in-stock width for a color (or all colors if color is null)
function getFirstInStockWidth(widths, color) {
  for (const width of widths) {
    const variant = findVariant(color, width);
    if (variant && variant.inventory_quantity > 0) return width;
  }
  return widths[0]; // fallback to first width if all are out of stock
}

// Sync the current variant id into the URL so refresh/share preserves selection
function updateLinearVariantUrl(variantId) {
  if (!variantId) return;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', variantId);
  window.history.replaceState({}, '', url);
  const v = window.linearProductData?.currentVariant;
  console.log('[Linear Variant] URL synced → variant=' + variantId + (v?.title ? ' (' + v.title + ')' : '') + ' | full URL: ' + url.toString());
}

// Find variant by color and width (color is optional)
function findVariant(color, width) {
  const variantMap = window.linearProductData?.variantMap || {};
  
  for (const [key, variant] of Object.entries(variantMap)) {
    const variantWidth = extractWidth(variant.title);
    if (!variantWidth || Math.abs(variantWidth - width) >= 0.01) continue;

    if (!color) {
      return variant;
    }

    const variantColor = extractColor(variant.title);
    if (variantColor && variantColor.toLowerCase() === color.toLowerCase()) {
      return variant;
    }
  }
  
  return null;
}

// Handle color selection
function selectLinearColor(button) {
  // Update UI
  document.querySelectorAll('.linear-color-swatch').forEach(btn => {
    btn.classList.remove('selected');
  });
  button.classList.add('selected');
  
  // Store selected color
  selectedColor = button.dataset.color;
  
  // Update color name display
  const colorNameEl = document.getElementById('linearSelectedColorName');
  if (colorNameEl) {
    colorNameEl.textContent = selectedColor;
  }
  
  // Reset width and calculations
  selectedWidth = null;
  document.getElementById('linearLengthInput').value = '';
  document.getElementById('linearAreaValue').textContent = '0.0';
  
  // Populate width dropdown
  const widths = getWidthsForColor(selectedColor);
  const widthSelect = document.getElementById('linearWidthSelect');

  widthSelect.innerHTML = '<option value="">Select width</option>';

  widths.forEach(width => {
    const option = document.createElement('option');
    option.value = width;
    option.textContent = width + 'm';
    widthSelect.appendChild(option);
  });

  // Auto-select first in-stock width to enable free sample button
  if (widths.length > 0) {
    const firstInStockWidth = getFirstInStockWidth(widths, selectedColor);
    widthSelect.value = firstInStockWidth;
    selectedWidth = firstInStockWidth;

    // Find and store variant info for the auto-selected width
    const variant = findVariant(selectedColor, firstInStockWidth);
    if (variant) {
      window.linearProductData.currentVariant = variant;
      updateLinearVariantImages(variant);
      updateStockAndPrice();
      updateLinearVariantUrl(variant.id);
    }
  } else {
    // Hide stock/price row if no widths available
    document.getElementById('linearStockPriceRow').style.display = 'none';
  }

  // Update button state
  updateAddToCartButton();
}

// Show length feedback message
function showLengthFeedback(message) {
  let feedbackEl = document.getElementById('linearLengthFeedback');

  // Create feedback element if it doesn't exist
  if (!feedbackEl) {
    feedbackEl = document.createElement('div');
    feedbackEl.id = 'linearLengthFeedback';
    feedbackEl.style.cssText = 'color: #dc2626; font-size: 13px; margin-top: 8px; padding: 8px 12px; background: #fef2f2; border-radius: 6px; display: none;';
    const calcBox = document.querySelector('.linear-calculator-box');
    const calcRow = document.querySelector('.linear-calc-row');
    if (calcBox && calcRow) {
      calcRow.insertAdjacentElement('afterend', feedbackEl);
    }
  }

  if (message) {
    feedbackEl.textContent = message;
    feedbackEl.style.display = 'block';
    // Auto-hide after 6 seconds
    setTimeout(() => {
      feedbackEl.style.display = 'none';
    }, 6000);
  } else {
    feedbackEl.style.display = 'none';
  }
}

// Calculate area live (without validation - for real-time feedback while typing)
function calculateLinearAreaLive() {
  const widthSelect = document.getElementById('linearWidthSelect');
  const lengthInput = document.getElementById('linearLengthInput');
  const areaValueEl = document.getElementById('linearAreaValue');

  const width = parseFloat(widthSelect.value) || 0;
  const length = parseFloat(lengthInput.value) || 0;

  // Store selected width
  if (width > 0) {
    selectedWidth = width;

    // Find and store variant info (selectedColor may be null for width-only products)
    const variant = findVariant(selectedColor, width);
    if (variant) {
      window.linearProductData.currentVariant = variant;
      updateLinearVariantImages(variant);
      updateStockAndPrice();
      updateLinearVariantUrl(variant.id);
    }
  }

  // Calculate area (show live calculation)
  const area = width * length;
  if (areaValueEl) {
    areaValueEl.textContent = area.toFixed(1);
  }

  // Update subtotal price
  updateSubtotalPrice(area);

  // Update button state
  updateAddToCartButton();
}

// Validate length on blur (when user finishes typing)
function validateLinearLength() {
  const lengthInput = document.getElementById('linearLengthInput');
  let length = parseFloat(lengthInput.value) || 0;

  // Enforce min/max length (2-25m)
  const minLength = 2;
  const maxLength = 25;

  if (length > 0 && length < minLength) {
    showLengthFeedback(`Minimum length is ${minLength}m. We've adjusted your selection.`);
    lengthInput.value = minLength;
    calculateLinearAreaLive(); // Recalculate with corrected value
  } else if (length > maxLength) {
    showLengthFeedback(`Maximum length is ${maxLength}m. We've adjusted your selection.`);
    lengthInput.value = maxLength;
    calculateLinearAreaLive(); // Recalculate with corrected value
  } else {
    showLengthFeedback(null); // Hide feedback if valid
  }
}

// Calculate area (with validation - used by width select)
function calculateLinearArea() {
  validateLinearLength();
  calculateLinearAreaLive();
}

// Update stock and price display when variant is selected
function updateStockAndPrice() {
  const variant = window.linearProductData?.currentVariant;
  const stockPriceRow = document.getElementById('linearStockPriceRow');
  const stockIndicator = document.getElementById('linearStockIndicator');
  const stockText = document.getElementById('linearStockText');
  const skuValueEl = document.getElementById('linearSkuValue');
  const sampleBtn = document.getElementById('linearSampleBtn');
  
  if (variant) {
    // Update SKU
    if (skuValueEl) {
      skuValueEl.textContent = variant.sku || 'N/A';
    }
    
    // Update Price
    const priceOnlyEl = document.querySelector('.linear-price-only');
    if (priceOnlyEl && variant.price) {
      const priceFormatted = '£' + (variant.price / 100).toFixed(2);
      priceOnlyEl.textContent = priceFormatted + '/m²';
    }
    
    // Update RRP (compare_at_price)
    const rrpContainer = document.querySelector('.linear-rrp-container');
    const vatContainer = document.querySelector('.linear-vat-container');
    const rrpPriceEl = document.querySelector('.linear-rrp-price');
    
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      // Show RRP container, hide VAT-only container
      if (rrpContainer) {
        rrpContainer.style.display = 'flex';
        if (rrpPriceEl) {
          const compareFormatted = '£' + (variant.compare_at_price / 100).toFixed(2);
          rrpPriceEl.textContent = compareFormatted + '/m²';
        }
      }
      if (vatContainer) {
        vatContainer.style.display = 'none';
      }
    } else {
      // Hide RRP container, show VAT-only container
      if (rrpContainer) {
        rrpContainer.style.display = 'none';
      }
      if (vatContainer) {
        vatContainer.style.display = 'block';
      }
    }
    
    // Check if variant has sample available (variant-level metafields)
    const sampleIsActive = variant.sample_linear_is_active;
    const sampleHandle = variant.sample_handle_linear;
    
    console.log('Sample debug:', { 
      variantTitle: variant.title,
      sampleIsActive, 
      sampleHandle,
      variant 
    });
    
    if (sampleBtn) {
      if (sampleIsActive && sampleHandle) {
        console.log('Showing sample button');
        sampleBtn.style.display = 'flex';
        sampleBtn.setAttribute('data-sample-handle', sampleHandle);
      } else {
        console.log('Hiding sample button - isActive:', sampleIsActive, 'handle:', sampleHandle);
        sampleBtn.style.display = 'none';
      }
    }
    
    // Show the stock/price row
    stockPriceRow.style.display = 'flex';
    
    const inventory = variant.inventory_quantity || 0;
    
    if (inventory > 0) {
      stockIndicator.classList.remove('out-of-stock');
      stockText.textContent = 'Available to order';
    } else {
      stockIndicator.classList.add('out-of-stock');
      stockText.textContent = 'Out of stock';
    }
    
    // Calculate and update subtotal
    const lengthInput = document.getElementById('linearLengthInput');
    const length = parseFloat(lengthInput.value) || 0;
    const widthSelect = document.getElementById('linearWidthSelect');
    const width = parseFloat(widthSelect.value) || 0;
    const area = width * length;
    
    updateSubtotalPrice(area);
  } else {
    // Hide the stock/price row
    stockPriceRow.style.display = 'none';
  }
}

// Update subtotal price and check stock levels
function updateSubtotalPrice(area) {
  const variant = window.linearProductData?.currentVariant;
  const subtotalPriceEl = document.getElementById('linearSubtotalPrice');
  const leadTimeMessage = document.getElementById('linearLeadTimeMessage');
  const addToCartBtn = document.querySelector('.linear-add-to-cart-btn');
  
  if (variant && area > 0) {
    const pricePerM2 = variant.price / 100;
    const totalPrice = area * pricePerM2;
    subtotalPriceEl.textContent = '£' + totalPrice.toFixed(2);
    
    // Check stock levels - quantity is area rounded up (1 unit = 1 sqm)
    const quantity = Math.ceil(area);
    const inventoryQuantity = variant.inventory_quantity || 0;
    const exceedsStock = inventoryQuantity <= 0 || quantity > inventoryQuantity;
    
    if (exceedsStock && leadTimeMessage) {
      // Show lead time message
      leadTimeMessage.style.display = 'block';
      setLinearLeadTimeContent();
      
      // Keep button enabled but user will see the lead time info
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
      }
    } else if (leadTimeMessage) {
      // Hide lead time message
      leadTimeMessage.style.display = 'none';
      
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
      }
    }
  } else {
    subtotalPriceEl.textContent = '£0.00';
    if (leadTimeMessage) {
      leadTimeMessage.style.display = 'none';
    }
  }
}

// Set lead time message content based on stock due date
function setLinearLeadTimeContent() {
  const leadTimeText = document.getElementById('linearLeadTimeText');
  if (!leadTimeText) return;
  
  const variant = window.linearProductData?.currentVariant;
  const inventoryQuantity = variant?.inventory_quantity || 0;
  const displayQuantity = Math.max(0, inventoryQuantity); // Ensure non-negative display
  const dueDate = leadTimeText.dataset.dueDate;
  const formattedDate = leadTimeText.dataset.formattedDate;
  const mainText = leadTimeText.dataset.mainText;
  const noDateText = leadTimeText.dataset.noDateText;
  const pastDateText = leadTimeText.dataset.pastDateText;
  const stockZeroText = leadTimeText.dataset.stockEqualTo0Text;
  const productTitle = leadTimeText.dataset.productTitle;
  
  // Helper function to replace all placeholders in text
  function replacePlaceholders(text) {
    if (!text) return text;
    // Replace [stock_units] with inventory quantity (wrapped in bold span)
    text = text.replace(/\[stock_units\]/gi, '<span class="linear-lead-time-bold">' + displayQuantity + '</span>');
    // Replace [stock_due_date] with formatted date (wrapped in bold span)
    if (formattedDate) {
      text = text.replace(/\[stock_due_date\]/gi, '<span class="linear-lead-time-bold">' + formattedDate + '</span>');
    }
    // Replace {date} placeholder
    if (formattedDate) {
      text = text.replace('{date}', '<span class="linear-lead-time-bold">' + formattedDate + '</span>');
    }
    // Replace product title placeholders
    text = text.replace('{product_title}', productTitle || 'this product');
    text = text.replace(/\[product_name\]/gi, '<span class="linear-lead-time-bold">' + (productTitle || 'this product') + '</span>');
    text = text.replace(/\[product name\]/gi, '<span class="linear-lead-time-bold">' + (productTitle || 'this product') + '</span>');
    // Replace "packs" with "linear meters" for linear products
    text = text.replace(/packs/gi, 'linear meters');
    text = text.replace(/pack/gi, 'linear meter');
    return text;
  }
  
  // Priority 1: If stock is 0 or negative
  if (inventoryQuantity <= 0 && stockZeroText) {
    leadTimeText.innerHTML = replacePlaceholders(stockZeroText);
    return;
  }
  
  // Priority 2: Check if due date is in the past
  if (dueDate) {
    const dateParts = dueDate.includes('-') ? dueDate.split('-') : dueDate.split('/');
    if (dateParts.length === 3) {
      const day = parseInt(dateParts[0]);
      const month = parseInt(dateParts[1]) - 1;
      const year = parseInt(dateParts[2]);
      const stockDate = new Date(year, month, day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (stockDate < today && pastDateText) {
        leadTimeText.innerHTML = replacePlaceholders(pastDateText);
        return;
      }
    }
  }
  
  // Priority 3: Show main text with date
  if (mainText && formattedDate) {
    leadTimeText.innerHTML = replacePlaceholders(mainText);
    return;
  }
  
  // Priority 4: No date available
  if (noDateText) {
    leadTimeText.innerHTML = replacePlaceholders(noDateText);
    return;
  }
  
  // Fallback message
  leadTimeText.innerHTML = 'We currently have <span class="linear-lead-time-bold">' + displayQuantity + '</span> linear meters in stock. You can still continue with your full order and we\'ll notify you when it\'s ready.';
}

// Update add to cart button state
function updateAddToCartButton() {
  const button = document.querySelector('.linear-add-to-cart-btn');
  const lengthInput = document.getElementById('linearLengthInput');
  const widthSelect = document.getElementById('linearWidthSelect');
  
  const hasColorSwatches = document.querySelector('.linear-color-swatch') !== null;
  const hasColor = !hasColorSwatches || selectedColor !== null;
  const hasWidth = widthSelect.value !== '';
  const hasLength = lengthInput.value !== '' && parseFloat(lengthInput.value) > 0;
  
  if (hasColor && hasWidth && hasLength) {
    button.disabled = false;
  } else {
    button.disabled = true;
  }
}

// Add to cart
function addLinearToCart() {
  const variant = window.linearProductData?.currentVariant;
  const areaValueEl = document.getElementById('linearAreaValue');
  
  if (!variant) {
    alert('Please select color and width');
    return;
  }
  
  const area = parseFloat(areaValueEl.textContent) || 0;
  
  if (area <= 0) {
    alert('Please enter a valid length');
    return;
  }
  
  // Calculate quantity (1 unit = 1 m²)
  const quantity = Math.ceil(area);
  
  console.log('Bundle check:', {
    bundleDataExists: typeof window.bundleData !== 'undefined',
    bundleData: window.bundleData,
    quantity: quantity,
    area: area
  });
  
  // Set up totalArea element for linear bundle calculations
  let tempTotalArea = document.getElementById('totalArea');
  if (!tempTotalArea) {
    tempTotalArea = document.createElement('span');
    tempTotalArea.id = 'totalArea';
    tempTotalArea.style.display = 'none';
    document.body.appendChild(tempTotalArea);
  }
  tempTotalArea.textContent = area.toFixed(2);

  let bundleShown = false;

  // Check if underlay bundle is available (underlay upsell)
  if (typeof window.bundleData !== 'undefined') {
    console.log('Bundle available - showing linear bundle option');

    // Update bundle data with current variant
    window.bundleData.flooringVariantId = variant.id;
    window.bundleData.flooringPrice = variant.price;
    window.bundleData.flooringProductTitle = window.linearProductData?.productTitle || 'Flooring';

    // Use linear-specific bundle function (1 underlay per 15 sqm)
    if (typeof showLinearBundleOption === 'function') {
      showLinearBundleOption(quantity, area);
      bundleShown = true;
    } else {
      console.error('showLinearBundleOption function not found');
    }
  }

  // Check if adhesive bundle is available (Roll Vinyl products)
  if (typeof window.linearAdhesiveBundleData !== 'undefined' && typeof showLinearAdhesiveOption === 'function') {
    console.log('Adhesive bundle available - showing linear adhesive option');

    // Update adhesive bundle data with current variant
    window.linearAdhesiveBundleData.flooringVariantId = variant.id;
    window.linearAdhesiveBundleData.flooringPrice = variant.price;
    window.linearAdhesiveBundleData.flooringProductTitle = window.linearProductData?.productTitle || 'Flooring';

    showLinearAdhesiveOption(quantity, area);
    bundleShown = true;
  }

  if (bundleShown) {
    return;
  }

  console.log('No bundle data - adding directly to cart');

  // No bundle available - add flooring directly
  addLinearJustFlooring(variant.id, quantity);
}

// Add just flooring to cart (without bundle)
function addLinearJustFlooring(variantId, quantity) {
  // Hide bundle if it's showing
  if (typeof hideLinearBundle === 'function') {
    hideLinearBundle();
  }

  // Get width and length values and variant SKU
  const widthSelect = document.getElementById('linearWidthSelect');
  const widthValue = widthSelect ? widthSelect.value : '0';
  const lengthInput = document.getElementById('linearLengthInput');
  const lengthValue = lengthInput ? lengthInput.value : '0';
  const variant = window.linearProductData?.currentVariant;
  const variantSku = variant?.sku || '';

  // Add to cart via Shopify API with properties
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
      properties: {
        'SKU': variantSku,
        'Width (m)': widthValue,
        'Length (m)': lengthValue,
        '_cut_id': Date.now().toString()
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    // Dispatch cart update event
    document.dispatchEvent(new CustomEvent('cart:update', { detail: data }));
    
    // Show toast notification
    if (typeof showCartSuccessToast === 'function') {
      showCartSuccessToast(quantity, window.linearProductData?.productTitle || 'Product');
    } else {
      alert('Added to cart successfully!');
    }
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    alert('Error adding to cart. Please try again.');
  });
}

// Add sample to cart function - uses global addSampleToCart from sample-cart-modal.liquid
function addLinearSampleToCart() {
  const variant = window.linearProductData?.currentVariant;
  
  if (!variant) {
    console.error('No variant selected');
    alert('Please select a color and width first');
    return;
  }
  
  const sampleHandle = variant.sample_handle_linear;
  const sampleIsActive = variant.sample_linear_is_active;
  
  if (!sampleIsActive || !sampleHandle) {
    console.error('Sample not available for this variant');
    alert('Sample not available for this variant');
    return;
  }
  
  console.log('Adding sample to cart:', sampleHandle);
  
  // Use global addSampleToCart function from sample-cart-modal.liquid
  if (typeof addSampleToCart === 'function') {
    const productTitle = window.linearProductData?.productTitle || 'Linear Product';
    const productImage = document.querySelector('.linear-main-image img')?.src || '';
    addSampleToCart(sampleHandle, productTitle, productImage);
  } else {
    console.error('addSampleToCart function not found - sample-cart-modal.liquid may not be loaded');
    alert('Error: Sample cart not loaded. Please refresh the page.');
  }
}

// Initialize on page load
function initializeLinearProduct() {
  console.log('Linear product initialized');
  console.log('Product data:', window.linearProductData);

  // Determine which color to select based on URL variant param or Shopify's selected variant
  let targetColor = null;
  const urlParams = new URLSearchParams(window.location.search);
  const urlVariantId = urlParams.get('variant');
  const initialVariantId = urlVariantId ? parseInt(urlVariantId, 10) : window.linearProductData?.variantId;

  console.log('[Linear Variant] Page load → URL ?variant param: ' + urlVariantId + ' | Shopify selected_or_first: ' + window.linearProductData?.variantId + ' | Resolved initial: ' + initialVariantId);

  if (initialVariantId) {
    const variantMap = window.linearProductData?.variantMap || {};
    for (const [key, variant] of Object.entries(variantMap)) {
      if (variant.id === initialVariantId) {
        targetColor = extractColor(variant.title);
        console.log('[Linear Variant] Page load → matched variant in map: ' + variant.id + ' (' + variant.title + ') | extracted color: ' + targetColor);
        break;
      }
    }
  }

  // Find the matching color swatch, or fall back to first swatch
  let swatchToSelect = null;
  if (targetColor) {
    swatchToSelect = document.querySelector(`.linear-color-swatch[data-color="${targetColor}"]`);
  }
  if (!swatchToSelect) {
    swatchToSelect = document.querySelector('.linear-color-swatch');
  }

  if (swatchToSelect) {
    console.log('Selecting color:', swatchToSelect.dataset.color);
    selectLinearColor(swatchToSelect);
  } else {
    console.log('No color swatches found - populating widths directly');
    // No color variants: populate width dropdown from all variants
    const widths = getWidthsForColor(null);
    const widthSelect = document.getElementById('linearWidthSelect');
    if (widthSelect) {
      widthSelect.innerHTML = '<option value="">Select width</option>';
      widths.forEach(width => {
        const option = document.createElement('option');
        option.value = width;
        option.textContent = width + 'm';
        widthSelect.appendChild(option);
      });
      if (widths.length > 0) {
        const firstInStockWidth = getFirstInStockWidth(widths, null);
        widthSelect.value = firstInStockWidth;
        selectedWidth = firstInStockWidth;
        const variant = findVariant(null, firstInStockWidth);
        if (variant) {
          window.linearProductData.currentVariant = variant;
          updateLinearVariantImages(variant);
          updateStockAndPrice();
          updateLinearVariantUrl(variant.id);
        }
      }
    }
  }

  // Check sample button initial state
  const sampleBtn = document.getElementById('linearSampleBtn');
  console.log('Sample button element:', sampleBtn);
  console.log('Sample button initial display:', sampleBtn ? sampleBtn.style.display : 'not found');

  // Set initial button state
  updateAddToCartButton();

  // Initialize swatches toggle (show more/less)
  initializeSwatchesToggle();
}

// Update images when variant is selected
function updateLinearVariantImages(variant) {
  console.log('=== VARIANT IMAGE UPDATE DEBUG ===');
  console.log('Full variant object:', variant);
  console.log('variant.variant_images_raw:', variant.variant_images_raw);
  console.log('variant.variant_iamges_raw (typo check):', variant.variant_iamges_raw);
  console.log('variant.all_metafields:', variant.all_metafields);
  console.log('variant.variant_images:', variant.variant_images);
  
  // Check if variant has custom images
  const variantImages = variant.variant_images || [];
  const hasVariantImages = variantImages.length > 0;
  
  console.log('Processed variantImages array:', variantImages);
  console.log('Has variant images:', hasVariantImages);
  console.log('Product images fallback:', window.linearProductData?.productImages);
  console.log('===================================');
  
  // Get image containers
  const mainImage = document.getElementById('linearMainImage');
  const thumbnailGrid = document.querySelector('.linear-thumbnail-grid');
  
  if (hasVariantImages) {
    // Use variant-specific images
    if (mainImage) {
      mainImage.src = variantImages[0];
    }
    
    // Update thumbnails
    if (thumbnailGrid) {
      thumbnailGrid.innerHTML = '';
      variantImages.slice(0, 4).forEach(imageUrl => {
        const thumbnailDiv = document.createElement('div');
        thumbnailDiv.className = 'linear-thumbnail';
        thumbnailDiv.onclick = () => changeLinearMainImage(imageUrl);
        
        const img = document.createElement('img');
        img.src = imageUrl.replace('width=800', 'width=200');
        img.alt = variant.title;
        
        thumbnailDiv.appendChild(img);
        thumbnailGrid.appendChild(thumbnailDiv);
      });
    }
  } else {
    // Fall back to product images
    console.log('No variant images, using product images');
    const productImages = window.linearProductData?.productImages || [];
    
    if (mainImage && productImages.length > 0) {
      mainImage.src = productImages[0];
    }
    
    // Restore original thumbnails
    if (thumbnailGrid && productImages.length > 1) {
      thumbnailGrid.innerHTML = '';
      productImages.slice(0, 4).forEach(imageUrl => {
        const thumbnailDiv = document.createElement('div');
        thumbnailDiv.className = 'linear-thumbnail';
        thumbnailDiv.onclick = () => changeLinearMainImage(imageUrl);
        
        const img = document.createElement('img');
        img.src = imageUrl.replace('width=800', 'width=200');
        img.alt = window.linearProductData?.productTitle || 'Product';
        
        thumbnailDiv.appendChild(img);
        thumbnailGrid.appendChild(thumbnailDiv);
      });
    }
  }
}

// Change main image when thumbnail is clicked
function changeLinearMainImage(imageSrc) {
  const mainImage = document.getElementById('linearMainImage');
  if (mainImage) {
    mainImage.src = imageSrc;
  }
}

// Toggle color swatches expand/collapse
function toggleLinearSwatches() {
  const swatches = document.getElementById('linearColorSwatches');
  const toggle = document.getElementById('linearSwatchesToggle');

  if (!swatches || !toggle) return;

  swatches.classList.toggle('expanded');
  toggle.classList.toggle('expanded');

  const toggleText = toggle.querySelector('.toggle-text');
  if (toggleText) {
    toggleText.textContent = swatches.classList.contains('expanded')
      ? 'Show less colours'
      : 'Show more colours';
  }
}

// Initialize swatches toggle visibility
function initializeSwatchesToggle() {
  const swatches = document.getElementById('linearColorSwatches');
  const toggle = document.getElementById('linearSwatchesToggle');

  if (!swatches || !toggle) return;

  // Check if swatches overflow (more than 1 row)
  // Each swatch is ~40px + 8px gap, so roughly 48px per swatch
  // If scrollHeight > maxHeight (88px), we have overflow
  const hasOverflow = swatches.scrollHeight > 88;

  if (hasOverflow) {
    toggle.classList.add('visible');
  } else {
    toggle.classList.remove('visible');
    swatches.classList.add('expanded'); // Show all if no overflow
  }
}

// Check and show/hide reviews section based on Yotpo content
function checkLinearReviews() {
  const ratingContainer = document.querySelector('.linear-rating');
  const yotpoWidget = document.querySelector('.linear-rating .yotpo-widget-instance');
  
  if (ratingContainer && yotpoWidget) {
    // Check if Yotpo has loaded content
    const hasContent = yotpoWidget.children.length > 0 || yotpoWidget.textContent.trim().length > 0;
    
    if (hasContent) {
      ratingContainer.style.display = 'flex';
    } else {
      ratingContainer.style.display = 'none';
    }
  }
}

// Run initialization
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeLinearProduct);
} else {
  initializeLinearProduct();
}

// Check reviews after a delay to allow Yotpo to load
setTimeout(checkLinearReviews, 1000);
setTimeout(checkLinearReviews, 2000);

// Also check when Yotpo fires its events
if (typeof yotpo !== 'undefined') {
  yotpo.on('reviews-loaded', checkLinearReviews);
}